module.exports = __webpack_public_path__ + "static/img/3.8a48d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/3.jpg
// module id = OXWZ
// module chunks = 1